export default __webpack_public_path__ + "media/images/react_icons/envelope_alt-02a5a7d4e5211e87984878a8607bc82f.svg";